import React from 'react'
import CustomButton from '../customButton/ui/main/CustomButton'
import { navigationContent } from '../../../constants/copyright'
import { useAppState, useContent } from '../../../redux/reducer/content'
import classNames from 'classnames'
import { useUser } from '../../../redux/reducer/user'
import { useMarkButtons } from '../../../hooks/useMarkButtons'
import { NAVIGATION_STATES } from '../../../constants/components/features/navigation/states'
import { CSSTransition } from 'react-transition-group'
import useStateControls from '../../../hooks/useStateControls'
import { useModal } from '../../../hooks/useModal'
import { useOnboardingContext } from '../../../providers/onboarding-provider'
import { ONBOARDING_STEPS_TYPES } from '../../../providers/onboarding-provider/constants'

const { buttons } = navigationContent

const Navigation = React.forwardRef(function (_, ref) {
  const state = useAppState()
  const { notFilteredShopItems, quests, gamesSettings } = useContent()
  const { profile } = useUser()
  const { setState } = useStateControls()
  const { closeModal } = useModal()

  const stateButtons = useMarkButtons({
    buttons,
    dependencies: [gamesSettings, notFilteredShopItems],
    prefixNavigation: {
      games: (count) => `gamesMark${count}`,
      customization: (count) => `customizationMark${count}`,
      challenges: (count) => `challengesMark${count}`,
    },
    availableNavigation: {
      games: gamesSettings?.filter(({ isAvailable }) => isAvailable)?.length,
      customization: notFilteredShopItems?.filter(
        ({ required_score }) => required_score <= profile?.score,
      )?.length,
      challenges: 1,
    },
  })

  const { openOnboardingModal, shouldShowOnboardingStep } = useOnboardingContext()

  const onClick = ({ extraCallback, action, onboardingStep }) => {
    extraCallback?.()
    setState(action)
    closeModal({ type: 'all' })

    if (onboardingStep === ONBOARDING_STEPS_TYPES.CHALLENGES) {
      if (shouldShowOnboardingStep(ONBOARDING_STEPS_TYPES.CHALLENGES)) {
        openOnboardingModal(ONBOARDING_STEPS_TYPES.CHALLENGES)
        return
      }

      if (shouldShowOnboardingStep(ONBOARDING_STEPS_TYPES.ACHIEVEMENTS)) {
        openOnboardingModal(ONBOARDING_STEPS_TYPES.ACHIEVEMENTS)
      }

      return
    }

    if (shouldShowOnboardingStep(onboardingStep)) {
      openOnboardingModal(onboardingStep)
    }
  }

  const getExtraProps = (extraCallback, type) => {
    return (
      {
        challenges: {
          backlight: false,
          count: quests?.reduce((acc, { completedCount }) => acc + completedCount, 0) || null,
        },
      }[type] ?? { isNew: !!extraCallback }
    )
  }

  return (
    <CSSTransition
      in={NAVIGATION_STATES.includes(state)}
      timeout={300}
      mountOnEnter
      unmountOnExit
      classNames={'navigation'}
    >
      <ul
        className={'navigation'}
        ref={ref}
      >
        {stateButtons?.map(
          ({ attr, icon, action, tutorId, type, gtm, extraCallback, onboardingStep }, id) => (
            <li
              key={`b-${id}`}
              className={classNames(`navigation__item navigation__item_${id + 1}`, {
                [`navigation__item_active navigation__item_active-${action}`]: action === state,
                'fill-stroke': action === 'challenges' && action === state,
              })}
            >
              <CustomButton
                {...attr}
                icon={icon}
                gtm={gtm}
                {...getExtraProps(extraCallback, type)}
                {...(tutorId && { 'data-tutor-id': tutorId })}
                onClick={() => onClick({ extraCallback, action, onboardingStep })}
              />
            </li>
          ),
        )}
      </ul>
    </CSSTransition>
  )
})
export default Navigation
Navigation.propTypes = {}
